import mergeConfig from '../../externals/axios/core/mergeConfig';
import normalize from '../normalize';
export default (function (requestFn, axiosInstance) {
    return function (requestConfig) {
        var instanceConfig = axiosInstance.defaults || {};
        // 将requestConfig merge 到 instanceConfig中
        var config = mergeConfig(instanceConfig, requestConfig);
        try {
            // 标准化处理url
            config.url = normalize(config.url);
        }
        catch (e) {
        }
        return requestFn(config);
    };
});
//# sourceMappingURL=wrapRequest.js.map